module.exports = __webpack_public_path__ + "static/media/help.18bef84f.svg";